module.exports = __webpack_public_path__ + "img/g-add.ab508154.svg";